import { useCallback, useMemo } from "react";

import { useApi } from "shared/services/api/useApi";
import { useQuery } from "react-query";

const useAccrualRulesApi = () => {
    const { getDataAsync } = useApi();

    const getAccrualRulesByFilterApiCall = useCallback(async ({ employeeTypeId, officeId, year }) => {

        const response = await getDataAsync("getAccrualRulesByFilter", {
            urlParams: [
                { name: "$employeeTypeId", value: employeeTypeId },
                { name: "$officeId", value: officeId },
                { name: "$year", value: year }
            ]
        });

        const result = response.status === 204
            ? null
            : response.json();

        return result;

    },
        [getDataAsync]
    );

    return useMemo(() => {
        const useGetAccrualRulesByFilter = (dataObj) =>
            useQuery(["getAccrualRulesByFilter", dataObj], () =>
                getAccrualRulesByFilterApiCall(dataObj)
            );

        return {
            useGetAccrualRulesByFilter
        };
    }, [getAccrualRulesByFilterApiCall]);
};

export default useAccrualRulesApi;
